import React,{useState} from 'react'
import styled from "styled-components"
const SnpPlusPlans = (props) => {
    const { planData } = props;
    const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
    const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };
    const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);
    let sendData = "";

const MainBlock = styled.div`

    // background: pink;
    height:auto;
    margin:20px 0;

    & .amount-block{
        // background: yellow;
        padding:10px;
    }
    & .amount-label{
       padding-left: 4px;
       color: #000
   
    }
    & .amount-input{
        background-color: #fff;
        border: 0px solid;
        box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
        border-radius: 2px;
        height: 40px;
        width: 100%;
        color: #CCC;
    }
    & .tenure-block{
        padding: 0px 10px;
       
    }
    & .tenure-label{
        padding-left: 4px;
        color: #000

    }
    & .EMI_tenure{
        padding-top:10px;
        background: #fff;
        border: 0px solid;
        box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
        border-radius: 4px;
       
    }

    & .radioSelect{
        font-size:14px;
        padding:10px;
        border: 1px solid rgba(0,0,0,0.1);
        border-radius: 6px;
        margin-left:8px;
        margin-bottom: 8px;
        width:45.5%;
        display: inline-block;
        color: #003E8D;
        font-weight:500;
        background: none;
    }
`;

const handleProceed = () => {
    if (sendData.length != 0) {
        let obj={
            tenure: sendData
        }
      let inputString =
        sendData +
        "<split>" +
        JSON.stringify(obj);
      window["autosubmit"](inputString);

      document.getElementById("showPlanData").style.pointerEvents = "none";
      setButtonStyle(buttonStyleDisabled);
    } else {
      props.overlayMessageToggle("Please select EMI duration to proceed");
    }
  };

const handleRadioChange = (selectedEMIPlan) => {
    sendData = selectedEMIPlan;
  };

  const showPlanData = (val) => {
    return (
      <div id="showPlanData">
        <MainBlock>
          <div className="tenure-block">
            <div className="EMI_tenure">
              {planData.map((item, i) => {
                return (
                  <div
                    className="radioSelect disable-item"
                    key={i}
                    onChange={() => handleRadioChange(item)}
                  >
                    <input
                      type="radio"
                      style={{ cursor: "pointer" }}
                      name="checkbox"
                    />
                    <label style={{ marginLeft: "1px" }}>
                        {item}
                      {/* {item.tenureInMonths} Months
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "300",
                          color: "#666666",
                        }}
                      >
                        Processing Fee: ₹{item.processingFee}
                      </div> */}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </MainBlock>
      </div>
    );
  };
  return (
    <React.Fragment>
      {showPlanData()}
      <div className="action-elem" onClick={() => handleProceed()}>Submit</div>
    </React.Fragment>
  );
}
export default SnpPlusPlans;